import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { WorkScheduleApiService } from './work-schedule.api.service';
import { WorkScheduleEffects } from './work-schedule.effects';
import {
  workScheduleReducer,
  workScheduleInitialState,
  IWorkScheduleState,
} from './work-schedule.reducer';
import { WorkScheduleService } from './work-schedule.service';
import { workScheduleFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IWorkScheduleState>(
      workScheduleFeatureKey,
      workScheduleReducer,
      {
        initialState: workScheduleInitialState,
      },
    ),
    EffectsModule.forFeature([WorkScheduleEffects]),
  ],
  providers: [WorkScheduleApiService, WorkScheduleService],
})
export class StoreWorkScheduleModule {}
